import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import { BeneficiariesResponse } from '@epi-models/pages/Transfer';

const url = `${config.apiHost}/api/company-beneficiaries`;

export function getCompanyBeneficariesRequest(
  abortController: AbortController | null = null
): Promise<BeneficiariesResponse> {
  return get(url, undefined, undefined, abortController?.signal);
}
